/** Heroicons solid icon keys — rendered via NavigationIcon atom. */
export const NAV_ICON_KEYS = {
  storeDashboard: 'storeDashboard',
  dashboard: 'dashboard',
  salesDashboard: 'salesDashboard',
  customers: 'customers',
  marketing: 'marketing',
  loyalty: 'loyalty',
  channels: 'channels',
  inventory: 'inventory',
  annotate: 'annotate',
  reports: 'reports',
  orders: 'orders',
  returns: 'returns',
  giftCards: 'giftCards',
  rewards: 'rewards',
  files: 'files',
  invoices: 'invoices',
  people: 'people',
  stores: 'stores',
  eventTypes: 'eventTypes',
  bookings: 'bookings',
  availability: 'availability',
  calendar: 'calendar',
  website: 'website',
  calendarSettings: 'calendarSettings',
  doctors: 'doctors',
  serviceAssistant: 'serviceAssistant',
  create: 'create',
  dataViz: 'dataViz',
  review: 'review',
  verify: 'verify',
  billing: 'billing',
  apiDoc: 'apiDoc',
  help: 'help',
  more: 'more',
  settings: 'settings',
  voice: 'voice',
};

export function getDashboardIconKey({ industry, isLegal, isDental }) {
  if (industry === 'Manufacturing') return NAV_ICON_KEYS.salesDashboard;
  if (isLegal || isDental) return NAV_ICON_KEYS.dashboard;
  return NAV_ICON_KEYS.storeDashboard;
}

export function getOrdersIconKey({ industry, isLegal, isDental }) {
  if (industry === 'Manufacturing') return NAV_ICON_KEYS.orders;
  if (isLegal || isDental) return NAV_ICON_KEYS.files;
  return NAV_ICON_KEYS.invoices;
}

export function getProjectsIconKey({ industry }) {
  if (industry === 'Manufacturing') return NAV_ICON_KEYS.stores;
  return NAV_ICON_KEYS.people;
}
